// extracted by mini-css-extract-plugin
export default {"assetsListContainer":"AssetsList_assetsListContainer__+HUgu","assetsListTableContainer":"AssetsList_assetsListTableContainer__L0eP3"};